import React, { forwardRef, memo, useImperativeHandle, useRef } from "react";

import "./pan-crop-overlay.css";

export interface IPanCropOverlayRef {
	el: HTMLDivElement;
	updateOverlay(
		zone: eXpress.core.IReadonlyPhotoLookZone | undefined,
		spreadDipToScreenFrame?: eXpress.math.Frame,
	): void;
}

/** Overlay on top of Preview that we can use to draw extra elements during photo panning/zooming */
export const PanCropOverlay = memo(
	forwardRef<IPanCropOverlayRef>((_, ref) => {
		/** Ref to DOM element */
		const divRef = useRef<HTMLDivElement | null>(null);

		/** Expose PreviewOverlay object via ref */
		useImperativeHandle(
			ref,
			() => eXpress.creator.rendering.createPanCropOverlay(divRef.current),
			[],
		);

		return <div className="pan-crop-overlay" ref={divRef} />;
	}),
);
PanCropOverlay.displayName = "PanCropOverlay";
